import { type KeyboardEvent as ReactKeyboardEvent, useRef } from 'react';
import { useIntl } from 'react-intl';

import { DownloadIcon } from '@dynatrace/strato-icons';

import { ChartToolbarRenderer } from '../../../core/components/toolbar/ChartToolbarRenderer.js';
import { useA11yToolbarTabIndex } from '../../../core/hooks/useA11yToolbarTabIndex.js';
import { useTimeseriesRawData } from '../../hooks/useTimeseriesRawData.js';
import { TIMESERIES_MESSAGES } from '../../messages/tooltips-text.js';
import { buildAndDownloadCsv } from '../../utils/download/build-and-download-csv.js';

export const DownloadDataButton = () => {
  const downloadDataButtonRef = useRef<HTMLButtonElement>(null);
  const tabIndex = useA11yToolbarTabIndex('download');
  const intl = useIntl();
  const rawData = useTimeseriesRawData();

  /** Handles the download button when event keydown.*/
  const handleDownloadDataKeyboard = (event: ReactKeyboardEvent) => {
    if (event.key === 'Enter') {
      buildAndDownloadCsv(rawData);
    }
  };

  /** Handles the download button when clicked. */
  const handleDownloadDataToolbar = () => {
    buildAndDownloadCsv(rawData);
  };

  return (
    <ChartToolbarRenderer.Control
      ref={downloadDataButtonRef}
      prefixIcon={<DownloadIcon />}
      tooltipText={intl.formatMessage(TIMESERIES_MESSAGES.downloadAsCsv)}
      onKeyDown={handleDownloadDataKeyboard}
      onClick={handleDownloadDataToolbar}
      tabIndex={tabIndex}
      divider="left"
    />
  );
};

DownloadDataButton['displayName'] = 'DownloadDataButton';
